<script setup lang="ts">
import { useDeleteProduct } from '../api/deleteProduct';
import { Assert } from 'shared/assert';
import { useProductStore } from 'shared/products/stores/productStore';
import { useRefereshProductStore } from '../commands/refreshProductStore';
import DeleteEntityDialog from '@/common/components/DeleteEntityDialog.vue';
import { useTemplateRef } from 'vue';

const dialog = useTemplateRef('dialog');

defineExpose({
  show
});

const deleteApi = useDeleteProduct();
const store = useProductStore();
const refreshStore = useRefereshProductStore();

function show(id: string) {
  dialog.value?.show(id);
}

async function onDelete(id: string) {
  const response = await deleteApi.execute({ id: id});
  return response;
}

async function getById(id: string) {
  await refreshStore.initialize();
  const entity = store.getById(id);
  Assert.definied(entity);
  return {
    id: entity.id,
    name: entity.name
  };
}

</script>

<template>
  <DeleteEntityDialog
    ref="dialog"
    :delete="onDelete"
    :get-by-id="getById"
    :translate="(t) => t.products.deleteDialog">
  </DeleteEntityDialog>
</template>
